import React from 'react';
import { Alert, AlertColor, SnackbarOrigin } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Snackbar from '@mui/material/Snackbar';
import { IconStatus } from '@/context/ToastContext/ToastContext';
import ErrorIcon from '@mui/icons-material/Error';

interface ToastInterface {
    open: boolean;
    position?: SnackbarOrigin;
    severity: AlertColor;
    onClose: () => void;
    label: string;
    icon: IconStatus;
}

const Toast: React.FC<React.PropsWithChildren<ToastInterface>> = ({
    open = false,
    position = { vertical: 'bottom', horizontal: 'center' },
    severity = 'info',
    onClose,
    label = '',
    icon,
}) => {
    const defineIcon = () => {
        switch (icon) {
            case 'loading':
                return (
                    <CircularProgress
                        size={18}
                        sx={{
                            '&.MuiCircularProgress-root': {
                                color: (theme) => theme.palette.text.primary,
                            },
                        }}
                    />
                );
            case 'error':
                return (
                    <ErrorIcon
                        sx={{
                            color: (theme) => theme.palette.text.primary,
                            width: '22px',
                            height: '22px',
                            padding: 0,
                            margin: 0,
                        }}
                    />
                );
            case 'success':
                return (
                    <CheckCircleIcon
                        sx={{
                            color: (theme) => theme.palette.text.primary,
                            width: '22px',
                            height: '22px',
                            padding: 0,
                            margin: 0,
                        }}
                    />
                );
            default:
                return <div />;
        }
    };

    return (
        <Snackbar
            anchorOrigin={position}
            open={open}
            onClose={onClose}
            key={`${position.vertical}${position.horizontal}`}
            sx={{ minWidth: '230px' }}
        >
            <Alert
                sx={{ minWidth: '230px' }}
                icon={defineIcon()}
                severity={severity}
                variant="filled"
            >
                {label}
            </Alert>
        </Snackbar>
    );
};

export default Toast;
